var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { defineMessages, FormattedHTMLMessage, FormattedMessage, injectIntl } from "react-intl";
import classNames from "classnames";
import usdtIcon from "../../assets/img/payment/usdt.svg";
import UsdtFormWithdraw from "./forms/UsdtFormWithdraw";
import { USDT_PROVIDER } from "../../constants/Withdraw";
var WITHDRAW_PROVIDERS = [
    {
        label: "USDT",
        img: usdtIcon
    }
];
var messages = defineMessages({
    title: {
        id: "withdraw.select_payment_method",
        defaultMessage: "Выберите способ снятия"
    },
    through: {
        id: "withdraw.through",
        defaultMessage: "Снятие через"
    }
});
var internalErrorMsg = {
    id: "withdraw.withdraw_form_internal_error",
    defaultMessage: "Внутренняя ошибка системы. Попробуйте позже"
};
var errors = defineMessages({
    "-1": {
        id: "withdraw.withdraw_form_user_not_have_permission",
        defaultMessage: "Нет прав на снятие средств"
    },
    "-4": {
        id: "withdraw.withdraw_form_not_enough_amount",
        defaultMessage: "Недостаточно средств"
    },
    "-7": {
        id: "withdraw.withdraw_form_wrong_password",
        defaultMessage: "Неверный пароль"
    },
    "-100": internalErrorMsg,
    "-1000": internalErrorMsg,
    "-10000": internalErrorMsg
});
var BironexWithdraw = /** @class */ (function (_super) {
    __extends(BironexWithdraw, _super);
    function BironexWithdraw() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedPayment: null
        };
        _this.handleClearSelectedPayment = function () {
            _this.props.clearWithdrawErrorAction();
            if (_this.state.selectedPayment) {
                _this.setState({ selectedPayment: null });
            }
            else {
                _this.props.history.push("/");
            }
        };
        _this.onPaymentSelect = function (providerLabel) {
            if (_this.state.selectedPayment !== providerLabel) {
                _this.props.clearWithdrawErrorAction();
            }
            _this.setState({ selectedPayment: providerLabel });
        };
        _this.handleUsdtSubmit = function (values) {
            var user = _this.props.user;
            var data = {
                Type: "Crypto",
                Withdrawal: __assign(__assign({}, values), { GamblerId: user.gamblerId })
            };
            _this.props.createWithdrawAction(data, USDT_PROVIDER);
        };
        _this.renderActiveForm = function () {
            if (_this.state.selectedPayment !== "USDT") {
                return null;
            }
            var usdtProps = {
                submitAction: _this.handleUsdtSubmit,
                languageId: _this.props.languageId,
                fetching: _this.props.fetching,
                user: _this.props.user,
                withdraw: _this.props.withdraw
            };
            return (_jsx("div", __assign({ className: "forms" }, { children: _jsx(UsdtFormWithdraw, __assign({}, usdtProps)) })));
        };
        return _this;
    }
    BironexWithdraw.prototype.renderError = function () {
        var error = this.props.withdraw.get("createWithdrawError");
        if (!error) {
            return null;
        }
        var msg = errors[error] || errors["-100"];
        return (_jsx("p", __assign({ className: "important important--withdraw rec", style: { margin: "15px 15px 0", paddingTop: "2px" } }, { children: _jsx(FormattedHTMLMessage, __assign({}, msg)) })));
    };
    BironexWithdraw.prototype.render = function () {
        var _this = this;
        var selectedPayment = this.state.selectedPayment;
        var listClass = "providers__list" + (selectedPayment ? " providers__list-selected" : "");
        return (_jsxs(React.Fragment, { children: [_jsxs("div", __assign({ className: classNames("new-withdraw__head withdraw__head", {
                        selected: selectedPayment
                    }) }, { children: [selectedPayment ? (_jsx("a", { className: "new-join__back", style: { cursor: "pointer" }, onClick: this.handleClearSelectedPayment })) : (_jsx(Link, { className: "new-join__back", to: "/" })), _jsx("span", { children: selectedPayment ? (this.props.intl.formatMessage(messages.through) +
                                " " +
                                selectedPayment.toUpperCase()) : (_jsx(FormattedMessage, __assign({}, messages.title))) })] })), _jsx("div", __assign({ className: listClass }, { children: WITHDRAW_PROVIDERS.map(function (provider) {
                        var active = selectedPayment === provider.label;
                        return (_jsx("div", __assign({ className: "providers__list__item-wrapper", onClick: function () { return _this.onPaymentSelect(provider.label); } }, { children: _jsx("div", __assign({ className: classNames("providers__list__item", { active: active }) }, { children: _jsx("img", { width: "auto", height: "40px", alt: provider.label, src: provider.img }) })) }), provider.label));
                    }) })), this.renderError(), _jsx("div", __assign({ className: "new-withdraw__wrapper", style: { padding: "20px" } }, { children: _jsx("div", __assign({ className: "toggle_content" }, { children: _jsx("div", __assign({ className: "body" }, { children: this.renderActiveForm() })) })) }))] }));
    };
    return BironexWithdraw;
}(Component));
BironexWithdraw.propTypes = {
    user: PropTypes.object.isRequired,
    languageId: PropTypes.number.isRequired,
    withdraw: PropTypes.object.isRequired,
    fetching: PropTypes.bool.isRequired,
    createWithdrawAction: PropTypes.func.isRequired,
    clearWithdrawErrorAction: PropTypes.func.isRequired,
    intl: PropTypes.object
};
export default injectIntl(withRouter(BironexWithdraw));



// WEBPACK FOOTER //
// ./src/components/withdraw/Bironex.jsx